<template>
  <div class="bg-white shadow-md rounded-lg border border-gray-200 overflow-hidden">
    <div class="flex items-center justify-between gap-4 p-5 bg-[#F8FAFC] border-b border-gray-200">
      <div class="flex items-center gap-3 min-w-0">
        <ToggleButton
          :value="enabled"
          :id="`toggle-${sectionKey}`"
          :label="''"
          @update:value="$emit('update:enabled', $event)"
        />
        <div class="min-w-0">
          <h3 class="text-base font-semibold text-slate-800 truncate">{{ title }}</h3>
          <p v-if="subtitle" class="text-sm text-slate-500 truncate">{{ subtitle }}</p>
        </div>
      </div>

      <div v-if="enabled" class="text-right shrink-0">
        <p class="text-xs text-slate-500">Monthly</p>
        <p class="font-semibold text-slate-800">
          <span v-if="onRequest" class="text-sm text-indigo-600">On request</span>
          <span v-else v-currency="monthlyCost" :key="monthlyCost">{{ monthlyCost }}</span>
        </p>
      </div>
    </div>

    <div v-if="enabled" class="p-5">
      <slot />
    </div>
  </div>
</template>

<script>
import ToggleButton from "@/components/ToggleButton.vue";

export default {
  name: "ConfigSection",
  components: { ToggleButton },
  props: {
    sectionKey: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    enabled: { type: Boolean, default: false },
    monthlyCost: { type: Number, default: 0 },
    onRequest: { type: Boolean, default: false },
  },
  emits: ["update:enabled"],
};
</script>
